import React, { useContext, useState } from 'react';
import { LoadingOverlay, openLoader, closeLoader } from 'components/loading-overlay/LoadingOverlay';

import { Btn } from 'components/btn/Btn';
import { useAlert } from 'modules/alerts';
import { SERVICE_UNAVAILABLE_MESSAGE } from 'config';
import { UserPlaidWrapper } from 'features/coordinator/enrollment/steps/PlaidButton/PlaidButton';
import { SetUserAchAccountBody, setUserAchAccount, AchAccountBody } from 'common/api/e-comm/ach';
import { useLocation, useHistory } from 'react-router-dom';
import { Routes } from 'routes';
import { PaymentOptionsContext } from '../context';
import { AddBankAccountPromptText } from './AddBankAccountPromptText';

export const OAuthFlow = () => {
    const { loader, reloadAchInfo } = useContext(PaymentOptionsContext);

    const params = new URLSearchParams(useLocation().search);
    const [isOAuth, setIsOAuth] = useState(Boolean(params.get('oauth_state_id')));
    const alert = useAlert();
    const history = useHistory();

    const onPlaidLinkSuccess = async <T,>(payload: T) => {
        // NOTE: Remove addr from local-storage in case we have one stored
        // not needed for this step.
        const selectedAddress = localStorage.getItem('addr');

        // CASE: selected address was lost from local-storage for some reason
        if (!selectedAddress) {
            // we should clear the `oauth_state_id` and show some error message
            history.replace(Routes.ShopAccountSettingsPaymentOptionsTab);
            alert({ message: SERVICE_UNAVAILABLE_MESSAGE });
            return;
        }

        const userAchPayload: SetUserAchAccountBody = {
            ...(payload as unknown as AchAccountBody),
            addressId: selectedAddress,
        };

        openLoader(loader?.current as LoadingOverlay);
        const response = await setUserAchAccount(userAchPayload);
        await reloadAchInfo();
        closeLoader(loader?.current as LoadingOverlay);

        if (response.error) {
            alert({ message: SERVICE_UNAVAILABLE_MESSAGE });
        }
        history.replace(Routes.ShopAccountSettingsPaymentOptionsTab);
    };

    return (
        <div>
            <AddBankAccountPromptText />
            <div>
                <UserPlaidWrapper
                    addressId={''}
                    onSuccess={onPlaidLinkSuccess}
                    isOAuth={isOAuth}
                    onExit={() => setIsOAuth(false)}
                >
                    {(openPlaid, isPlaidReady: boolean) => (
                        <Btn onClick={openPlaid} disabled={!isPlaidReady}>
                            Continue with Plaid
                        </Btn>
                    )}
                </UserPlaidWrapper>
            </div>
        </div>
    );
};
